export const isMinute = (document) => {
    return document?.file?.filename?.toLocaleLowerCase().includes('minutes');
};
